export default __webpack_public_path__ + "static/media/amir.19792d63.png";